import React from 'react'
import InventoryItem from './InventoryItem'

const EquipmentSlot = ({
  slotType,
  item,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onDrop,
  onClick,
  className = '',
  dragClasses = '',
  disabled = false,
  disabledReason = '',
}) => {
  const handleDragOver = (e) => {
    if (disabled) {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'none'
      return
    }
    e.preventDefault()
    if (onDragOver) {
      onDragOver(e, 'equipment', slotType)
    }
  }

  const handleDragEnter = (e) => {
    if (disabled) {
      e.preventDefault()
      return
    }
    if (onDragEnter) {
      onDragEnter(e, 'equipment', slotType)
    }
  }

  const handleDragLeave = (e) => {
    if (onDragLeave) {
      onDragLeave(e)
    }
  }

  const handleDrop = (e) => {
    e.preventDefault()
    if (disabled) return
    if (onDrop) {
      onDrop(e, 'equipment', slotType)
    }
  }

  const handleClick = () => {
    if (disabled) return
    if (onClick && item) {
      onClick(item, slotType, 'equipment')
    }
  }

  const getSlotLabel = (slotType) => {
    const labels = {
      head: 'Casco',
      chest: 'Pecho',
      hands: 'Guantes',
      legs: 'Pantalones',
      feet: 'Botas',
      mainHand: 'Mano Principal',
      offHand: 'Mano Secundaria',
      ring1: 'Anillo I',
      ring2: 'Anillo II',
      necklace: 'Collar',
      earring1: 'Pendiente I',
      earring2: 'Pendiente II',
      consumable0: 'Consumible I',
      consumable1: 'Consumible II',
      consumable2: 'Consumible III',
      consumable3: 'Consumible IV',
      consumable4: 'Consumible V',
    }
    if (labels[slotType]) return labels[slotType]
    if (String(slotType).startsWith('consumable')) return 'Consumible'
    return slotType
  }

  const title = disabled
    ? disabledReason || 'Ocupada por arma a dos manos'
    : getSlotLabel(slotType)

  return (
    <div
      className={`inventory__equipment-slot ${className} ${dragClasses}${
        disabled ? ' inventory__equipment-slot--disabled' : ''
      }`}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      data-slot-type={slotType}
      data-disabled={disabled ? 'true' : undefined}
      aria-disabled={disabled || undefined}
      title={title}
    >
      {item && !disabled ? (
        <InventoryItem
          item={item}
          index={slotType}
          sourceType="equipment"
          slotType={slotType}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onClick={handleClick}
          className="equipment-item"
        />
      ) : (
        <div className={`inventory__equipment-slot-item empty-slot${disabled ? ' empty-slot--disabled' : ''}`}>
          <div className="slot-placeholder">
            <span className="slot-icon">{getSlotIcon(slotType)}</span>
            <span className="slot-label">
              {disabled ? 'Dos manos' : getSlotLabel(slotType)}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

const getSlotIcon = (slotType) => {
  const icons = {
    head: '⛑️',
    chest: '🦺',
    hands: '🧤',
    legs: '👖',
    feet: '👢',
    mainHand: '⚔️',
    offHand: '🛡️',
    ring1: '💍',
    ring2: '💍',
    necklace: '📿',
    earring1: '✨',
    earring2: '✨',
    consumable0: '🧪',
    consumable1: '🧪',
    consumable2: '🧪',
    consumable3: '🧪',
    consumable4: '🧪',
  }
  if (icons[slotType]) return icons[slotType]
  if (String(slotType).startsWith('consumable')) return '🧪'
  return '📦'
}

export default EquipmentSlot
